import React, { forwardRef } from 'react'

import { cn } from 'utils'
import { mergeRefs } from 'utils/ref_utils'

import { useClearableState } from './hooks/useClearableState'
import { useInputMask } from './hooks/useInputMask'
import { SolidCircleCheckIcon } from './icons/SolidCircleCheck'
import { ClearButton, TextLikeFormField, type TextLikeFormFieldProps } from './TextLikeFormField'

export interface TelephoneInputProps extends Omit<TextLikeFormFieldProps, 'className' | 'children'>, React.InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
  placeholder?: string;
  validated?: boolean;
}

export const TelephoneInput = forwardRef<HTMLInputElement, TelephoneInputProps>(({
  validated,
  ...props
}, forwardedRef) => {
  const { clearValue, handleChange, ref, isClearable } = useClearableState(
    props.defaultValue,
    props.value,
    props.onChange
  )

  const { clearMask } = useInputMask(
    ref,
    '((999) 999-9999|1 (999) 999-9999)'
  )

  return (
    <TextLikeFormField {...props}>
      {(formFieldProps) => (
        <>
          <input
            {...formFieldProps}
            className={cn(formFieldProps.className, {
              'pr-2 group-hover/field:pr-7 group-focus-within/field:pr-7':
                isClearable && !validated,
              'pr-7 group-hover/field:pr-12 group-focus-within/field:pr-12':
                isClearable && validated,
            })}
            onChange={handleChange}
            ref={mergeRefs(ref, forwardedRef)}
            type='tel'
          />
          {!props.disabled && (isClearable || validated) && (
            <div className='flex items-center absolute right-1 top-0 bottom-0'>
              {isClearable && (
                <ClearButton
                  onClick={() => {
                    clearMask()
                    clearValue()
                  }}
                />
              )}
              {validated && (
                <span className='text-green-400 pointer-events-none pr-1'>
                  <SolidCircleCheckIcon size={16} />
                </span>
              )}
            </div>
          )}
        </>
      )}
    </TextLikeFormField>
  )
})
